export default __webpack_public_path__ + "static/media/Intersemibold.a0267c90.woff2";